import React from "react";
import { Table } from "react-bootstrap";

const CategoryTable = () => {
    const data = [
        { category: "Baby Diapers (All Sizes)", oldUser: "05%", newUser: "10%" },
        { category: "Wet Wipes", oldUser: "05%", newUser: "10%" },
        { category: "Nappy Bags", oldUser: "05%", newUser: "10%" },
        { category: "Kids Toothbrushes", oldUser: "05%", newUser: "10%" },
        { category: "New Mom Gift Package", oldUser: "05%", newUser: "10%" },
        { category: "Sanitary Pads (Florence)", oldUser: "05%", newUser: "10%" },
    ];

    return (

        <>
            <div className="container categorytable mt-5">
                <div className="row">

                    <div className="col-12">
                        <h2 className="text-center fw-bold my-3">
                            Affiliate Commission Percentage
                        </h2>
                    </div>

                    <Table bordered responsive className="custom-table">
                        <thead className="custom-header">
                            <tr className="bg" >
                                <th className="custom-header">Category</th>
                                <th className="custom-header">Old User</th>
                                <th className="custom-header">New User</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.category}</td>
                                    <td>{item.oldUser}</td>
                                    <td>{item.newUser}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    );
};

export default CategoryTable;
